(function () {
  'use strict';

  function initBlogCarousel() {
    if (window.innerWidth > 768) return;

    const articleList = document.querySelector('.blog-row .article-list');
    if (!articleList) return;
    if (articleList.dataset.carouselInit) return;
    articleList.dataset.carouselInit = 'true';

    const articles = articleList.querySelectorAll('.article');
    const total = articles.length;
    if (total <= 1) return;

    let currentIndex = 0;
    let startX = 0;
    let startTranslate = 0;
    let isDragging = false;
    let currentTranslate = 0;

    // ── 1. Create clip wrapper that breaks out of container padding ──
    const clipWrapper = document.createElement('div');
    clipWrapper.style.cssText = [
      'overflow: hidden',
      'width: 100vw',
      'position: relative',
      'left: 50%',
      'transform: translateX(-50%)',
      'box-sizing: border-box'
    ].join(';');

    articleList.parentNode.insertBefore(clipWrapper, articleList);
    clipWrapper.appendChild(articleList);

    // ── 2. Style the track ────────────────────────────────────────
    articleList.style.cssText = [
      'display: flex',
      'flex-wrap: nowrap',
      'overflow: visible',
      'transition: transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
      'will-change: transform',
      'margin: 0',
      'padding: 0'
    ].join(';');

    // ── 3. Each card = 100vw, with inner padding for breathing room ──
    articles.forEach(function (article) {
      article.style.cssText = [
        'flex: 0 0 100vw',
        'max-width: 100vw',
        'min-width: 100vw',
        'box-sizing: border-box',
        'padding: 0 24px',
        'animation-delay: 0s'
      ].join(';');
    });

    // ── 4. Dot indicators ─────────────────────────────────────────
    const dotsWrapper = document.createElement('div');
    dotsWrapper.classList.add('blog-carousel-dots');

    articles.forEach(function (_, i) {
      const btn = document.createElement('button');
      btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      if (i === 0) btn.classList.add('active');
      btn.addEventListener('click', function () { goToSlide(i); });
      dotsWrapper.appendChild(btn);
    });

    // ── 5. "View All Blogs" button ────────────────────────────────
    const viewAllBtn = document.createElement('a');
    viewAllBtn.href = '/blogs/news';
    viewAllBtn.classList.add('blog-carousel-view-all');
    viewAllBtn.textContent = 'View All Blogs';

    // Insert dots then view all button after the clip wrapper
    clipWrapper.after(viewAllBtn);
    clipWrapper.after(dotsWrapper);

    // ── 6. Slide logic ────────────────────────────────────────────
    function goToSlide(index) {
      currentIndex = Math.max(0, Math.min(index, total - 1));
      currentTranslate = -(window.innerWidth * currentIndex);
      articleList.style.transform = 'translateX(' + currentTranslate + 'px)';

      dotsWrapper.querySelectorAll('button').forEach(function (btn, i) {
        btn.classList.toggle('active', i === currentIndex);
      });
    }

    // ── 7. Touch swipe ────────────────────────────────────────────
    clipWrapper.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startTranslate = currentTranslate;
      isDragging = true;
      articleList.style.transition = 'none';
    }, { passive: true });

    clipWrapper.addEventListener('touchmove', function (e) {
      if (!isDragging) return;
      const diff = e.touches[0].clientX - startX;
      articleList.style.transform = 'translateX(' + (startTranslate + diff) + 'px)';
    }, { passive: true });

    clipWrapper.addEventListener('touchend', function (e) {
      if (!isDragging) return;
      isDragging = false;
      articleList.style.transition = 'transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      const diff = startX - e.changedTouches[0].clientX;
      if (diff > 50 && currentIndex < total - 1) {
        goToSlide(currentIndex + 1);
      } else if (diff < -50 && currentIndex > 0) {
        goToSlide(currentIndex - 1);
      } else {
        goToSlide(currentIndex);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBlogCarousel);
  } else {
    initBlogCarousel();
  }

})();